import React from 'react';
import Apresentacao from 'Loja/components/compLoja/Apresentacao';
import LandingPage from 'Loja/components/compLoja/LandingPage';

function LojaIndex() {
  return (
    <div className="lpmain-container">
      <LandingPage />
    </div>
  );
}

export default LojaIndex;